import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { PostSasReportListResponseModel } from '../models/models'

export class PostSasReportListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReport/outdatedSASReport',
      requesterInfo,
    })
  }

  public async PostSasReportList(): Promise<PostSasReportListResponseModel[]> {
    return await this.postAsync<PostSasReportListResponseModel[]>()
  }
}